<script setup>
import { useI18n } from 'vue-i18n';
import EnRestrictedAccessIcon from 'Components/icons/EnRestrictedAccessIcon.vue';
import EnButton from 'Components/base/EnButton';

const { t } = useI18n();

function contactCustomerService() {
  window.location.href = 'mailto:hilfe@enloc.de';
}

function goBack() {
  // Read position directly from browser history state (Vue Router stores it there),
  // so this works even when the component renders outside a router context.
  const position = window.history.state?.position ?? 0;
  if (position <= 1) {
    window.location.href = '/';
    return;
  }
  const deepLevel = parseInt(localStorage.getItem('back-navigation-level') ?? '1');
  window.history.go(-deepLevel);
}
</script>

<template>
  <div
    class="flex min-h-[calc(100vh-56px-64px-64px-40px-40px)] flex-col items-center justify-center bg-background px-4 py-16 text-center"
  >
    <en-restricted-access-icon
      class="mb-10 inline-block w-auto text-[clamp(48px,12vw,100px)] leading-none max-[576px]:mb-2"
    ></en-restricted-access-icon>

    <h1 class="mb-4 text-[clamp(1.4rem,2.5vw,1.8rem)] font-bold text-en-blue-500 font-[Inter,sans-serif]">
      {{ t('common.restrictedAccess.title') }}
    </h1>

    <p class="mx-auto mb-10 max-w-180 px-4 text-[clamp(1rem,2vw,1.2rem)] leading-[1.45] text-en-blue-400">
      {{ t('common.restrictedAccess.text') }}
    </p>

    <div class="flex flex-col justify-center gap-3 md:flex-row">
      <en-button
        class="mb-3 md:mb-0"
        size="xs"
        static-id="contact-customer-service-button"
        variant="default"
        @click="contactCustomerService"
      >
        {{ t('common.restrictedAccess.contactButton') }}
      </en-button>
      <en-button
        size="xs"
        static-id="go-back-button"
        @click="goBack"
      >
        {{ t('common.restrictedAccess.backButton') }}
      </en-button>
    </div>
  </div>
</template>
